import React from 'react';
import { PencilLine } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { RichTextEditor } from '../RichTextEditor';
import TranslateButton from '../TranslateButton';
import { EditorCard, Field, inputCls } from './ui';

export const BasicInfoCard = ({ form, set }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const fields = [{ source: 'titleAr', target: 'titleEn' }, { source: 'subtitleAr', target: 'subtitleEn' }, { source: 'descriptionAr', target: 'descriptionEn' }, { source: 'brandAr', target: 'brandEn' }];
  return (
    <EditorCard testId="course-basic-card" Icon={PencilLine} title={L('المعلومات الأساسية', 'Basic information')} desc={L('أدخل المعلومات الرئيسية للكورس', 'Enter the main course information')}
      action={<TranslateButton sourceLang="ar" targetLang="en" getValues={() => form} setValue={set} fields={fields} testId="course-translate-ar-en" />}>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label={L('اسم الكورس بالعربية', 'Course name (Arabic)')} required>
          <input data-testid="course-title-ar" dir="rtl" className={inputCls} placeholder={L('مثال: أساسيات برمجة PLC', 'e.g. أساسيات برمجة PLC')} value={form.titleAr} onChange={e => set('titleAr', e.target.value)} />
        </Field>
        <Field label={L('اسم الكورس بالإنجليزية (يُترجم تلقائياً إن تُرك فارغاً)', 'Course name (English, auto-translated if empty)')}>
          <input data-testid="course-title-en" dir="ltr" className={inputCls} placeholder="Example: PLC Basics" value={form.titleEn} onChange={e => set('titleEn', e.target.value)} />
        </Field>
        <Field label={L('عنوان فرعي بالعربية', 'Subtitle (Arabic)')}>
          <input data-testid="course-subtitle-ar" dir="rtl" className={inputCls} placeholder={L('وصف مختصر جذاب للكورس', 'Short catchy subtitle')} value={form.subtitleAr} onChange={e => set('subtitleAr', e.target.value)} />
        </Field>
        <Field label={L('عنوان فرعي بالإنجليزية', 'Subtitle (English)')}>
          <input data-testid="course-subtitle-en" dir="ltr" className={inputCls} placeholder="Short and attractive subtitle" value={form.subtitleEn} onChange={e => set('subtitleEn', e.target.value)} />
        </Field>
        <Field label={L('وصف الكورس بالعربية', 'Description (Arabic)')} required>
          <RichTextEditor testId="course-desc-ar" dir="rtl" value={form.descriptionAr} onChange={v => set('descriptionAr', v)}
            placeholder={L('اكتب وصفاً مفصلاً عن الكورس، ماذا سيتعلم الطالب، لمن هو مناسب، وما هي أهم المواضيع...', 'Detailed course description...')} />
        </Field>
        <Field label={L('وصف الكورس بالإنجليزية (يُترجم تلقائياً إن تُرك فارغاً)', 'Description (English, auto-translated if empty)')}>
          <RichTextEditor testId="course-desc-en" dir="ltr" value={form.descriptionEn} onChange={v => set('descriptionEn', v)}
            placeholder="Write a detailed course description, what the student will learn, who it is for, and the main topics covered..." />
        </Field>
      </div>
    </EditorCard>
  );
};
